/**
 * Build the initial context passed to `createMedriteCheckinMachine`.
 *
 * Extracted from the kiosk provider so the exact config-shape the provider
 * hands to the machine is unit-testable. The provider resolves the launch ids
 * (URL-authoritative, cache fallback) and then calls this to assemble the
 * machine's initial context.
 *
 * Every resolved id the machine needs to start a check-in must be threaded
 * through here. In particular `ehrLocationId` is required config: the machine's
 * `isEhrLocationIdMissing` fail-safe dead-ends a kiosk at `notConfigured` when
 * it is absent, so omitting it here would block every configured kiosk.
 */

import type { MedriteCheckinInitialContext } from "../machine/medrite-checkin.machine";

export interface KioskMachineConfigInput {
  qrMode: boolean;
  practiceId: string | null | undefined;
  appointmentId: string | null | undefined;
  ehrLocationId: string | null | undefined;
  stripeReaderId: string | null | undefined;
}

export function buildKioskMachineConfig(
  input: KioskMachineConfigInput,
): MedriteCheckinInitialContext {
  return {
    qrMode: input.qrMode,
    pendingPricesMode: false,
    practiceId: input.practiceId || undefined,
    appointmentId: input.appointmentId || undefined,
    // Must reach the machine alongside practiceId — without it the
    // isEhrLocationIdMissing fail-safe routes every configured kiosk to
    // notConfigured.
    ehrLocationId: input.ehrLocationId || undefined,
    // orgId / orgName default until practice-lookup wiring lands.
    orgId: 24,
    orgName: "Medrite",
    stripeReaderId: input.stripeReaderId || undefined,
  };
}
